import React from 'react';
import SvgComponent from './svg';


export default function CurrentLocationMobileIcon(props) {
  return <SvgComponent {...props} />;
}
